import { useTheme } from "@/components/context/ThemeContext";
import styles from "./detail-info.module.css";

export default function TournamentInfo({ tournament }) {
  const { theme } = useTheme();
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const safeCurrentRegistrations = Math.max(
    0,
    tournament?.currentRegistrations ?? 0,
  );
  const safeMaxPlayers = Math.max(0, tournament?.maxPlayers ?? 0);

  return (
    <div className={`${styles.infoCard} ${theme}`}>
      <h2 className={styles.sectionTitle}>Tournament Details</h2>

      <div className={styles.infoGrid}>
        <div className={styles.infoItem}>
          <span className={styles.label}>Tournament Date</span>
          <span className={styles.value}>
            {formatDate(tournament.tournamentDate)}
          </span>
        </div>

        <div className={styles.infoItem}>
          <span className={styles.label}>Registration Deadline</span>
          <span className={styles.value}>
            {formatDate(tournament.registrationDeadline)}
          </span>
        </div>

        <div className={styles.infoItem}>
          <span className={styles.label}>Game</span>
          <span className={styles.value}>{tournament.game}</span>
        </div>

        <div className={styles.infoItem}>
          <span className={styles.label}>Max Players</span>
          <span className={styles.value}>{tournament.maxPlayers}</span>
        </div>

        <div className={styles.infoItem}>
          <span className={styles.label}>Entry Fee</span>
          <span className={styles.value}>
            {tournament.registrationPrice
              ? `₹${tournament.registrationPrice}`
              : "Free"}
          </span>
        </div>

        <div className={styles.infoItem}>
          <span className={styles.label}>Current Registrations</span>
          <span className={styles.value}>
            {safeCurrentRegistrations}/{safeMaxPlayers}
          </span>
        </div>
      </div>

      <div className={styles.discordSection}>
        <h3 className={styles.discordTitle}>Join Our Community</h3>
        <a
          href={tournament.discordLink}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.discordButton}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.211.375-.444.864-.607 1.25a18.27 18.27 0 00-5.487 0c-.163-.386-.395-.875-.608-1.25a.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.08.08 0 00.087-.027c.461-.63.873-1.295 1.226-1.994a.076.076 0 00-.042-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.713 10.713 0 00.372-.294.075.075 0 01.078-.01c3.928 1.793 8.18 1.793 12.062 0a.075.075 0 01.079.009c.12.098.246.198.373.294a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.076.076 0 00-.041.107c.359.698.77 1.364 1.225 1.994a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-4.718-.838-8.812-3.549-12.454a.061.061 0 00-.031-.03zM8.02 15.33c-1.183 0-2.157-.965-2.157-2.156 0-1.193.93-2.157 2.157-2.157 1.226 0 2.157.964 2.157 2.157 0 1.191-.93 2.156-2.157 2.156zm7.975 0c-1.183 0-2.157-.965-2.157-2.156 0-1.193.93-2.157 2.157-2.157 1.226 0 2.157.964 2.157 2.157 0 1.191-.931 2.156-2.157 2.156z" />
          </svg>
          Join Discord
        </a>
      </div>
    </div>
  );
}
